import { render, staticRenderFns } from "./financeiro-backoffice-chat-list.vue?vue&type=template&id=565a81cf&scoped=true"
import script from "./financeiro-backoffice-chat-list.vue?vue&type=script&lang=ts"
export * from "./financeiro-backoffice-chat-list.vue?vue&type=script&lang=ts"
import style0 from "./financeiro-backoffice-chat-list.vue?vue&type=style&index=0&id=565a81cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565a81cf",
  null
  
)

export default component.exports